import React from "react";
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { Library, Upload, ArrowRight } from "lucide-react";
import { mockData } from "../mock";

const BestPracticeHubSection = () => {
  const { bestPracticeHub } = mockData;

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto text-center">
          {/* Clean Header - Welcome.com Style */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Best Practice
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-teal-600"> 
              {" "}Hub
            </span>
          </h2>
          
          {/* Professional Subtitle */}
          <p className="text-xl md:text-2xl text-gray-600 max-w-4xl mx-auto mb-8 leading-relaxed font-medium">
            A curated library of proven sustainability practices from certified organizations worldwide
          </p>
          
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-500 to-teal-500 mx-auto rounded-full mb-16"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
            {/* Explore Practices Card */}
            <Card className="group hover:shadow-lg transition-all duration-300 border-0 bg-white p-8">
              <CardContent className="p-0">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-emerald-500 to-emerald-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Library className="h-8 w-8 text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Explore Practices
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Browse field-tested sustainability practices from certified organizations, organized by pillar and industry sector.
                </p>

                <a href="/best-practices">
                  <Button 
                    className="bg-gradient-to-r from-emerald-500 to-emerald-600 text-white hover:from-emerald-600 hover:to-emerald-700 transition-all duration-300 font-semibold"
                  >
                    Browse Library
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </a>
              </CardContent>
            </Card>

            {/* Share Practices Card */}
            <Card className="group hover:shadow-lg transition-all duration-300 border-0 bg-white p-8">
              <CardContent className="p-0">
                <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <Upload className="h-8 w-8 text-white" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  Share Your Impact
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  Submit your organization's proven practices and help other businesses accelerate their sustainability journey.
                </p>

                <a href="/signup">
                  <Button 
                    variant="outline" 
                    className="border-teal-300 text-teal-600 hover:bg-teal-50 transition-all duration-300 font-semibold"
                  >
                    Submit Practice
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </a>
              </CardContent>
            </Card>
          </div>

          {/* Clean CTA Section */}
          <div className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Join the Community of Practice
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed max-w-3xl mx-auto">
              Access exclusive insights, contribute to collective knowledge, and accelerate your sustainability impact with proven methodologies.
            </p>
            <a href="/signup">
              <Button 
                size="lg"
                className="bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 text-white px-8 py-4 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
              >
                Get Started Today
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BestPracticeHubSection;